import React, { FC } from 'react'
import styles from './GitftCardLink.module.scss'
import GiftCardIconSvg from 'svg/gift-card-action-icon.svg'
import SALink from 'components/SALink'

const GiftCardLink: FC = () => {
  return (
    <SALink 
      href='/giftcard' 
      data-gtm-event='top-nav'
      data-type='gift-card'
      rel='nofollow'
    >
      <GiftCardIconSvg data-type='gift-card' className={styles.giftCardIcon} />
    </SALink>
  )
}

export default GiftCardLink